import type { FieldSubscription } from '@/js/libs/final-form';
import { useField } from '@/js/libs/final-form';

interface UseErrorSubscriptionProps<TName extends string> {
  name: TName;
  subscription?: FieldSubscription;
  withTouched?: boolean;
}

const useErrorSubscription = <TName extends string>(props: UseErrorSubscriptionProps<TName>) => {
  const { name, subscription = { touched: true, error: true, submitError: true }, withTouched = true } = props;

  const {
    meta: { touched, error, submitError },
  } = useField(name, { subscription });
  const isTouched = withTouched ? touched : true;

  return {
    isTouched,
    error,
    submitError,
    hasAnyError: (isTouched && error) || submitError,
  };
};

export default useErrorSubscription;
